import { NgModule } from '@angular/core';
import { DotCmsGenerateLinkPipe } from './dot-cms-generate-router-link.pipe';
import { DotCmsDescriptionPipe } from './dot-cms-description.pipe';
import { DotCmsCodecEncodePipe } from './dot-cms-codec-encode.pipe';

@NgModule({
  imports: [],
  declarations: [DotCmsGenerateLinkPipe, DotCmsGenerateLinkPipe, DotCmsDescriptionPipe, DotCmsCodecEncodePipe],
  exports: [DotCmsGenerateLinkPipe, DotCmsGenerateLinkPipe, DotCmsDescriptionPipe, DotCmsCodecEncodePipe],
})
export class DotCmsPipesModule {}
